import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './i18next';
import './shared/styles/vendors/index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
